(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/logotype-provider/assets/javascripts/provider.js') >= 0) return;  svs.modules.push('/components/content/logotype-provider/assets/javascripts/provider.js');

'use strict';

const isServer = typeof exports === 'object';
const nameSafeString = function () {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const safeString = string.replace(/^[.\s]+/g, '').replace(/[?!"()&€%]/g, '').replace(/[@]/g, '_a_').replace(/[åäáà]/gi, 'a').replace(/[é]/gi, 'e').replace(/[ö]/gi, 'o').replace(/[^a-z0-9._-]/gi, '-').toLowerCase();
  return safeString;
};
const getImages = async (req, configName, configParentId) => {
  if (isServer) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    const useNewApis = await req.feature('ft-admin-use-new-alfresco-apis');
    if (useNewApis) {
      const fetch = trinidad.svsFetch(req);
      const response = await fetch("/cms-admin/v2/sitesetting/name/".concat(configName, "?parentId=").concat(configParentId));
      if (!response.ok) {
        return null;
      }
      return await response.json();
    }
    const path = "/proxy/cms/".concat(trinidad.options.routesDomain, "/rest/v2/sitesetting/name/").concat(configName, "?parentId=").concat(configParentId);
    const options = {
      method: 'GET',
      path,
      req
    };
    try {
      return await trinidad.jupiter.callAsync(options);
    } catch (err) {
      return null;
    }
  }

  const useNewApis = svs.core.detect.feature('ft-admin-use-new-alfresco-apis');
  if (useNewApis) {
    const fetch = svs.core.svsFetch.create();
    const configParentIdResolved = configParentId || "svs-sites-".concat(svs.core.config.data.svsconfig.site, "-settings");
    const response = await fetch("/cms-admin/v2/sitesetting/name/".concat(configName, "?parentId=").concat(configParentIdResolved), {
      credentials: 'include'
    });
    if (!response.ok) {
      return null;
    }
    return await response.json();
  }
  const jupiter = svs.core.jupiter;
  const routesDomain = svs.core.config.data.svsconfig.routesDomain;
  const path = "/proxy/cms/".concat(routesDomain, "/rest/v2/sitesetting/name/").concat(configName, "?parentId=").concat(configParentId);
  const response = await jupiter.get(path);
  if (response) {
    return response;
  }
};
const getLogotypes = async (req, configName, configParentId) => {
  const data = await getImages(req, configName, configParentId);
  const siteSettingString = data.siteSetting,
    imageRelations = data.imageRelations;
  const siteSetting = siteSettingString && JSON.parse(siteSettingString) || {};
  const logotypes = siteSetting.logotypes;
  const output = logotypes.map(logotype => {
    logotype.id = nameSafeString(logotype.name);
    return logotype;
  });
  return {
    imageRelations,
    logotypes: output
  };
};
if (isServer) {
  module.exports = {
    getLogotypes
  };
} else {
  svs.content.logotypeProvider = {
    getLogotypes
  };
}

 })(window);